/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2ActiveSuspension } from './MatchOperationV2ActiveSuspension';
import {
    MatchOperationV2ActiveSuspensionFromJSON,
    MatchOperationV2ActiveSuspensionFromJSONTyped,
    MatchOperationV2ActiveSuspensionToJSON,
    MatchOperationV2ActiveSuspensionToJSONTyped,
} from './MatchOperationV2ActiveSuspension';
import type { MatchOperationV2Ruleset } from './MatchOperationV2Ruleset';
import {
    MatchOperationV2RulesetFromJSON,
    MatchOperationV2RulesetFromJSONTyped,
    MatchOperationV2RulesetToJSON,
    MatchOperationV2RulesetToJSONTyped,
} from './MatchOperationV2Ruleset';
import type { MatchOperationV2Permissions } from './MatchOperationV2Permissions';
import {
    MatchOperationV2PermissionsFromJSON,
    MatchOperationV2PermissionsFromJSONTyped,
    MatchOperationV2PermissionsToJSON,
    MatchOperationV2PermissionsToJSONTyped,
} from './MatchOperationV2Permissions';
import type { MatchOperationV2State } from './MatchOperationV2State';
import {
    MatchOperationV2StateFromJSON,
    MatchOperationV2StateFromJSONTyped,
    MatchOperationV2StateToJSON,
    MatchOperationV2StateToJSONTyped,
} from './MatchOperationV2State';

/**
 * 
 * @export
 * @interface MatchOperationV2Snapshot
 */
export interface MatchOperationV2Snapshot {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2Snapshot
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2Snapshot
     */
    streamId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2Snapshot
     */
    sourceType: MatchOperationV2SnapshotSourceType;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2Snapshot
     */
    operationMode: MatchOperationV2SnapshotOperationMode;
    /**
     * 
     * @type {MatchOperationV2Ruleset}
     * @memberof MatchOperationV2Snapshot
     */
    ruleset: MatchOperationV2Ruleset;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MatchOperationV2Snapshot
     */
    _configuration: { [key: string]: any; };
    /**
     * Private frozen teamA/teamB rosters. Players and officials may include firstName (all given names) and lastName (all family names) alongside displayName. Older snapshots are enriched only when the current participant ID and full name still match; otherwise the separate name fields may be absent. Public snapshots do not expose names.
     * @type {{ [key: string]: any; }}
     * @memberof MatchOperationV2Snapshot
     */
    participants: { [key: string]: any; };
    /**
     * 
     * @type {MatchOperationV2State}
     * @memberof MatchOperationV2Snapshot
     */
    state: MatchOperationV2State;
    /**
     * 
     * @type {Array<MatchOperationV2ActiveSuspension>}
     * @memberof MatchOperationV2Snapshot
     */
    activeSuspensions: Array<MatchOperationV2ActiveSuspension>;
    /**
     * 
     * @type {MatchOperationV2Permissions}
     * @memberof MatchOperationV2Snapshot
     */
    permissions: MatchOperationV2Permissions;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2Snapshot
     */
    revision: number;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationV2Snapshot
     */
    serverTime: Date;
}

/**
* @export
* @enum {string}
*/
export enum MatchOperationV2SnapshotSourceType {
    Tournament = 'TOURNAMENT',
    League = 'LEAGUE',
    AdHoc = 'AD_HOC'
}
/**
* @export
* @enum {string}
*/
export enum MatchOperationV2SnapshotOperationMode {
    ResultOnly = 'RESULT_ONLY',
    LiveMatchOperations = 'LIVE_MATCH_OPERATIONS'
}


/**
 * Check if a given object implements the MatchOperationV2Snapshot interface.
 */
export function instanceOfMatchOperationV2Snapshot(value: object): value is MatchOperationV2Snapshot {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('streamId' in value) || value['streamId'] === undefined) return false;
    if (!('sourceType' in value) || value['sourceType'] === undefined) return false;
    if (!('operationMode' in value) || value['operationMode'] === undefined) return false;
    if (!('ruleset' in value) || value['ruleset'] === undefined) return false;
    if (!('_configuration' in value) || value['_configuration'] === undefined) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('activeSuspensions' in value) || value['activeSuspensions'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('serverTime' in value) || value['serverTime'] === undefined) return false;
    return true;
}

export function MatchOperationV2SnapshotFromJSON(json: any): MatchOperationV2Snapshot {
    return MatchOperationV2SnapshotFromJSONTyped(json, false);
}

export function MatchOperationV2SnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2Snapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'streamId': json['streamId'],
        'sourceType': json['sourceType'],
        'operationMode': json['operationMode'],
        'ruleset': MatchOperationV2RulesetFromJSON(json['ruleset']),
        '_configuration': json['configuration'],
        'participants': json['participants'],
        'state': MatchOperationV2StateFromJSON(json['state']),
        'activeSuspensions': ((json['activeSuspensions'] as Array<any>).map(MatchOperationV2ActiveSuspensionFromJSON)),
        'permissions': MatchOperationV2PermissionsFromJSON(json['permissions']),
        'revision': json['revision'],
        'serverTime': (new Date(json['serverTime'])),
    };
}

export function MatchOperationV2SnapshotToJSON(json: any): MatchOperationV2Snapshot {
    return MatchOperationV2SnapshotToJSONTyped(json, false);
}

export function MatchOperationV2SnapshotToJSONTyped(value?: MatchOperationV2Snapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'streamId': value['streamId'],
        'sourceType': value['sourceType'],
        'operationMode': value['operationMode'],
        'ruleset': MatchOperationV2RulesetToJSON(value['ruleset']),
        'configuration': value['_configuration'],
        'participants': value['participants'],
        'state': MatchOperationV2StateToJSON(value['state']),
        'activeSuspensions': ((value['activeSuspensions'] as Array<any>).map(MatchOperationV2ActiveSuspensionToJSON)),
        'permissions': MatchOperationV2PermissionsToJSON(value['permissions']),
        'revision': value['revision'],
        'serverTime': value['serverTime'].toISOString(),
    };
}

